import { navigate } from '@reach/router';
import { IResult, UAParser } from 'ua-parser-js';

export const clearUrlParams = () => {
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  if (params?.size) {
    const newUrl = window.location.href.replace(window.location.search, '');
    navigate(newUrl, { replace: true });
  }
};

export const HttpStatusCodes = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

// Check if the code is running on the client side
export const isClient = typeof window !== 'undefined';

// Get user agent information
export const getUserAgent = (): IResult | null => {
  if (isClient) {
    const parser = new UAParser();
    return parser.getResult();
  }
  return null;
};

// Get an item from local storage
export const getLocalStorageItem = (key: string): string | null => {
  if (isClient) {
    return localStorage.getItem(key);
  }
  return null;
};

// Set an item in local storage
export const setLocalStorageItem = (key: string, value: string) => {
  if (isClient) {
    localStorage.setItem(key, value);
  }
};

// get app store link
export const getAppStoreLink = () => {
  const appStoreLanguage = getAppstoreLanguage();
  const appId = process.env.GATSBY_IOS_APP_ID;

  return appId
    ? `https://apps.apple.com/${appStoreLanguage}/app/livat/id${appId}`
    : undefined;
};

// get play store link
export const getPlayStoreLink = () => {
  const appId = process.env.GATSBY_ANDROID_APP_ID;

  return appId
    ? `https://play.google.com/store/apps/details?id=${appId}`
    : undefined;
};

// get language from browser for app store
export const getAppstoreLanguage = () => {
  return isClient ? window.navigator.language.slice(-2) || 'us' : 'us';
};

export const replaceNullWithQuotesJson = (obj: {
  [key: string]: any;
}): { [key: string]: string } => {
  Object.keys(obj).forEach((key: string) => {
    if (obj[key] == null) {
      obj[key] = '';
    }
  });
  return obj;
};

export const allowedHostsInRichText = [
  'player.vimeo.com',
  'player.vimeo.com/embed',
  'www.youtube.com',
  'youtube.com',
  'youtube.com/',
  'youtu.be',
];

// Helper function to sort by priority
export const sortByPriority = (a: any, b: any) => {
  if (a.priority !== 50 && a.priority !== null) {
    if (b.priority !== 50 && b.priority !== null) {
      return a.priority - b.priority;
    }
    return -1;
  }
  if (b.priority !== 50 && b.priority !== null) {
    return 1;
  }
  return 0;
};

export const getLocale = (langCode: string, fallback = 'en-US') => {
  const localeMap: { [key: string]: string } = {
    en: 'en-US',
    pt: 'pt-PT',
  };

  return localeMap[langCode] || fallback;
};

export const checkIfValidUser = (response = {}) => {
  //error handling
  const responseKeys = Object.keys(response);
  return responseKeys.length > 0 && !responseKeys.includes('message');
};
